export default {
  home: {
    card: {
      res: {
        imgRes: require('src/assets/reservation.jpg'),
        imgQueue: require('src/assets/queue.jpg'),
        title: '立即预约',
        title_en: 'Reservation',
      },
    },
  },
  grade: {
    primary: '大众会员',
    golden: '黄金会员',
    platinum: '铂金会员',
    diamond: '钻石会员',
  },
  date: {
    week: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
    am: '上午',
    pm: '下午',
  },
  famPicker: {
    instruction: '添加家庭成员',
    addAdult: '添加成人',
    addChild: '添加小孩',
  },
  addAdult: {
    title: '邀请TA扫码一起参观',
    instruction: '用支付宝扫二维码,一起参观',
    warning: ['该支付宝二维码将于', '失效'],
    download: ['点击下载二维码', '发送给朋友'],
    pending: ['扫码成功, 等待对方确认', '请对方在手机上确认'],
    success: ['添加成功'],
    rejected: ['邀请失败'],
  },
  btn: {
    nextStep: '下一步',
    resNow: '立即预约',
    complete: '完成',
    rescheduleConfirm: '确定改签',
    delete: '删除',
  },
  me: {
    fam: {
      title: '家庭成员',
      // subtitle: '可添加1个成人, 2个儿童一起体验展项',
      subtitle: '可添加1个儿童一起体验展项',
    },
    res: {
      title: '我的预约',
    },
    footprint: {
      title: '我的足迹',
      subtitle: '查看游戏成绩, 或数码纪念品',
    },
  },
  exhibits: [
    {
      name: '飞跃蚂蚁森林',
      icon: require('src/assets/icons/c.png'),
    },
    {
      name: '5G赛车',
      icon: require('src/assets/icons/d.png'),
    },
    {
      name: '互动区',
      icon: require('src/assets/icons/e.png'),
    },
    {
      name: '阿里动物园',
      icon: require('src/assets/icons/b.png'),
    },
    {
      name: '微笑商店',
      icon: require('src/assets/icons/f.png'),
    },
    {
      name: '甜品站',
      icon: require('src/assets/icons/h.png'),
    },
    {
      name: '支音楼梯',
      icon: require('src/assets/icons/g.png'),
    },
  ],
}
